import Translations from "../../libs/Translations";
import React from "react";
import * as Attributes from "../../libs/Attributes";
import { isViewDossier } from "../../libs/UrlHelpers";
import AttributesStore from "../../stores/AttributesStore";
import createReactClass from "create-react-class";
import ElstrLangStore from "elstr-jslib/src/scripts/stores/ElstrLangStore";
import PropTypes from "prop-types";
import { arrayMoveImmutable } from "../../libs/Array";
import { DndContext } from "@dnd-kit/core";
import { SortableContext, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

function toDisableCheckbox(dataAttributeKey) {
  // we disable the attribute "sMatHdrTdline" since it is redundant in the dossier functionality
  return dataAttributeKey === "sMatHdrTdline" && isViewDossier();
}

const SortableItem = props => {
  const { dataAttributeKey, checked } = props.attribute;
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: dataAttributeKey,
  });
  let classNameCheckbox = "item-setting-list__item";
  const label = Translations.getLabel(dataAttributeKey) || "";

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const id = `setting--${dataAttributeKey}`;

  if (checked) classNameCheckbox += " item-setting-list__item--checked";
  return (
    <li ref={setNodeRef} className={classNameCheckbox} style={style} {...attributes} {...listeners}>
      <input
        id={id}
        className="item-setting-list__checkbox"
        type="checkbox"
        name={dataAttributeKey}
        checked={checked}
        disabled={toDisableCheckbox(dataAttributeKey)}
        // https://github.com/clauderic/dnd-kit/issues/1264#issuecomment-2112384617
        onPointerDown={e => e.stopPropagation()}
        onChange={() => AttributesStore.toggleAttributes(checked, dataAttributeKey, props.type)}
      />
      <label
        // https://github.com/clauderic/dnd-kit/issues/1264#issuecomment-2112384617
        onPointerDown={e => e.stopPropagation()}
        htmlFor={id}
      >
        {label}
      </label>
      <span className="ficon ficon__table-option item-setting-list__option" />
    </li>
  );
};

const SortableList = ({ attributes, type }) => {
  function getClassName(type) {
    let className = `item-list__setting-layer`;
    if (type === Attributes.TYPES.packagingDossier) {
      className = `item-list__setting-layer-packaging-dossier`;
    }

    if (type !== Attributes.TYPES.result) {
      className = `${className} ${className}__dossier`;
    }
    return className;
  }

  return (
    <div className={getClassName(type)}>
      <ul className="item-setting__list">
        {attributes
          .filter(attribute => attribute.allowed)
          .map(attribute => (
            <SortableItem key={`item-${attribute.dataAttributeKey}`} attribute={attribute} type={type} />
          ))}
      </ul>
    </div>
  );
};

// from example: https://docs.dndkit.com/presets/sortable
const ItemListOverlaySettings = createReactClass({
  mixins: [AttributesStore.mixin, ElstrLangStore.mixin],

  propTypes: {
    type: PropTypes.string.isRequired, // Attributes.TYPE
  },

  _setState: function () {
    return Attributes.getSortableAttributesByType(this.props.type);
  },

  getInitialState: function () {
    return this._setState();
  },

  storeDidChange: function () {
    this.setState(this._setState());
  },

  onDragEnd: function (that, event) {
    const { type } = this.props;
    const { items } = this.state;
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = items.indexOf(active.id);
      const newIndex = items.indexOf(over.id);

      const attributes = Attributes.getAttributesByType(type);
      const newAttributesOrder = arrayMoveImmutable(attributes, oldIndex, newIndex);

      AttributesStore.setAttributesByType(newAttributesOrder, type);
    }
  },

  render: function () {
    let that = this;

    return (
      <DndContext onDragEnd={this.onDragEnd.bind(this, that)}>
        <SortableContext items={this.state.items} strategy={verticalListSortingStrategy}>
          <SortableList attributes={this.state.attributes} type={this.props.type} />
        </SortableContext>
      </DndContext>
    );
  },
});

export default ItemListOverlaySettings;
